import React, { useEffect, useRef, useState } from 'react';
import {
  initialValues,
  whenType,
  DoseType,
  medicineTypeWS,
} from "./InitialValues.js";
import Button from 'react-bootstrap/esm/Button';
import Select from "react-select";
import { useSelector } from "react-redux";
import {
  getListCancerTemplate,
  getListCancerOrder,
  getSelectedChemoOrder,
  getDataCancerTemplate,
  addNewCancerTemplate, updateChemoOrder, updatePrescriptionChemoOrder, saveLabPrescriptionChemoOrder,
  updateLabPrescriptionChemoOrder,
  sendLabPrescriptionChemoOrder,
  cancelLabPrescriptionChemoOrder, getAllConsultants,
  updateFrequencies,
  getFrequencies,
  getAllWondersoftDrugs,
  getDrugById, addChemoOrder,
  sendPrescriptionChemoOrderWondersoft,
  savePrescriptionChemoOrder
} from "../../../../core/services/api";
import { getTestsList } from 'core/services/api/patientDiagnosisService';
import Toast from 'components/Toast';
import { checkIcdDrugInteraction } from "core/services/api/patientClinicalService";
import FollowUpPrint from 'components/FollowUpVisit/FollowUpPrint';
import { DragDropContext, Draggable, Droppable } from "@atlaskit/pragmatic-drag-and-drop-react-beautiful-dnd-migration";
import moment from "moment";
import Print from 'components/Print/Print';
import PreMedicationRow from './PreMedicationRow';
import ChemotherapyRow from './ChemotherapyRow';
import TakeHomeMedicineRow from './TakeHomeMedicineRow';
import SideEffectsWS from './SideEffectsWS';

function AddNewChemoOrderWS({ patientInfo, order, isEditableOrder, readOnly, smartSummaryDetails, appointment, redirectPendingOrder, handleChemoOrderUpdation, pendingOrDelete }: any) {


  const preMedication = {
    id: "",
    prescriptionId: "",
    sideEffectPreMed: false,
    sideEffectTakeHome: false,
    medicines: [
      {
        id: "",
        drugId: "",
        type: "",
        typeOptions: [],
        medicineName: "",
        dose: "",
        when: "",
        frequency: "",
        duration: "",
        instructions: "",
        selectedSideEffects: [],
        sideEffectCheck: false,
        route: "",
        wondersoftProductCode: ""
      },
    ],
    isCancelled: false,
    readyToSent: false,
    prescriptionDocument: {
      id: "",
      createdAt: "",
      updatedAt: "",
      createdBy: "",
      updatedBy: "",
      name: "",
      blobUrl: "",
      category: "PATIENT",
    },
  }

  const chemotherapyAdministration = {
    id: "",
    prescriptionId: "",
    sideEffectPreMed: false,
    sideEffectTakeHome: false,
    sideEffectChemo: true,
    medicines: [
      {
        id: "",
        drugId: "",
        type: "",
        typeOptions: [],
        medicineName: "",
        dose: "",
        standardDose: "",
        doseModification: "",
        when: "",
        frequency: "",
        duration: "",
        instructions: "",
        selectedSideEffects: [],
        sideEffectCheck: false,
        route: "",
        wondersoftProductCode: ""
      },
    ],
    isCancelled: false,
    readyToSent: false,
    prescriptionDocument: {
      id: "",
      createdAt: "",
      updatedAt: "",
      createdBy: "",
      updatedBy: "",
      name: "",
      blobUrl: "",
      category: "PATIENT",
    },
  }

  const takeHomeMedicine = {
    id: "",
    prescriptionId: "",
    sideEffectPreMed: false,
    sideEffectTakeHome: false,
    medicines: [
      {
        id: "",
        drugId: "",
        type: "",
        typeOptions: [],
        medicineName: "",
        dose: "",
        when: "",
        frequency: "",
        duration: "",
        instructions: "",
        selectedSideEffects: [],
        sideEffectCheck: false,
        route: "",
        wondersoftProductCode: ""
      },
    ],
    isCancelled: false,
    readyToSent: false,
    prescriptionDocument: {
      id: "",
      createdAt: "",
      updatedAt: "",
      createdBy: "",
      updatedBy: "",
      name: "",
      blobUrl: "",
      category: "PATIENT",
    },
  }

  const preMedicationMedicine = {
    id: "",
    drugId: "",
    type: "",
    typeOptions: [],
    medicineName: "",
    dose: "",
    when: "",
    frequency: "",
    duration: "",
    instructions: "",
    selectedSideEffects: [],
    sideEffectCheck: false,
    route: "",
    wondersoftProductCode: ""
  }

  const chemotherapy = {
    id: "",
    drugId: "",
    type: "",
    typeOptions: [],
    medicineName: "",
    dose: "",
    doseModification: "",
    when: "",
    frequency: "",
    duration: "",
    instructions: "",
    selectedSideEffects: [],
    standardDose: "",
    sideEffectCheck: false,
    route: "",
    wondersoftProductCode: ""
  }

  const takeHome = {
    id: "",
    drugId: "",
    type: "",
    typeOptions: [],
    medicineName: "",
    dose: "",
    when: "",
    frequency: "",
    duration: "",
    instructions: "",
    selectedSideEffects: [],
    sideEffectCheck: false,
    route: "",
    wondersoftProductCode: ""
  }

  const testRequired = {
    tests: [
      {
        serviceId: "",
        testName: "",
        instructions: "",
        when: "",
      },
    ],
    prescriptionDocument: null,
    isSent: false,
    isCancelled: false
  }

  const initialTest = {
    serviceId: "",
    testName: "",
    instructions: "",
    when: "",
  }


  const InitialValuesTestRequired = [
    {
      "serviceId": 10,
      "serviceCode": "V000010",
      "serviceName": "Visit (50)"
    },
    {
      "serviceId": 11,
      "serviceCode": "V000011",
      "serviceName": "Visit (100)"
    },
    {
      "serviceId": 12,
      "serviceCode": "V000012",
      "serviceName": "Visit (150)"
    },
    {
      "serviceId": 30,
      "serviceCode": "",
      "serviceName": "Adenosine Deaminase(Ada), Serum"
    }]


  const InitialExaminationOption = {
    ecog: [
      "0 - Fully active, able to carry on all pre-disease performance without restriction",
      "1 - Restricted in physically strenuous activity but ambulatory and able to carry out work of a light or sedentary nature, e.g., light house work, office work",
      "2 - Ambulatory and capable of all selfcare but unable to carry out any work activities; up and about more than 50% of waking hours",
      "3 - Capable of only limited selfcare; confined to bed or chair more than 50% of waking hours",
      "4 - Completely disabled; cannot carry on any selfcare; totally confined to bed or chair",
      "5 - Dead",
    ]
  }
  const ecogOptions = InitialExaminationOption.ecog.map((ele: any) => {
    return { label: ele, value: ele }
  })


  //fetching diagnosis from smart summary
  const [selectedInputValues, setSelectedInputValues] = useState<any>({
    preMedication: [],
    takeHome: [],
    chemotherapyAdministration: [],
    freq: []
  })
  const [smartSummaryData, setSmartSummaryData] = useState<any>()
  const [appointmentDetails, setAppointmentDetails] = useState<any>({})
  const [inputValue, setInputValue] = useState<any>('');
  const [options1, setOptions1] = useState<any>([]);
  const [inputValueChemo, setInputValueChemo] = useState<any>('');
  const [options1Chemo, setOptions1Chemo] = useState<any>([]);
  const [inputValueTake, setInputValueTake] = useState<any>('');
  const [optionsTake, setOptionsTake] = useState<any>([]);
  const [updatedDragEvent, setUpdatedDragEvent] = useState<any>()
  const [showToast, setShowToast] = useState(false)
  const [freqDose, setFreqDose] = useState<any>([])
  const [selectedFreq, setSelectedFreq] = useState<any>(null);


  useEffect(() => {
    getFrequencies(`${userDetail?.currentCenter?.centerId}`)
      .then((res: any) => {
        if (res && res.length > 0) {
          setFreqDose(res)
        } else {
          setFreqDose([])
        }
      })
      .catch((err: any) => {
        console.log("frequency error", err)
      })
  }, [])


  useEffect(() => {
    if (appointment) {
      setAppointmentDetails(appointment)
    }
  }, [appointment])

  useEffect(() => {
    if (smartSummaryDetails) {
      setSmartSummaryData(smartSummaryDetails)
    }
  }, [smartSummaryDetails])

  const diagnosisValues = smartSummaryData?.diagnosis?.map((item: any) => {
    return `${item?.diagnosis}${item?.diagnosis ? ` (${item?.cancerType})` : `${item?.cancerType}`}`
  })


  const componentRef = useRef(null);

  //Initial Values------------------------------------------------------------------------end

  //toast Message
  const [displayToast, toggleDisplayToast] = useState<any>()
  const [cycleNoError, setcycleNoError] = useState<any>(false)


  //Initial Values for chemo Order
  const [initialValue, setInitialValue] = useState<any>(initialValues);
  const [selectedOptionLoadChemo, setSelectedOptionLoadChemo] = useState<any>()
  const [totalMedicinesNew, setTotalMedicinesNew] = useState<any>([]);
  useEffect(() => {
    getAllWondersoftDrugs()
      .then((res: any) => {
        setTotalMedicinesNew(res)
      })
      .catch((err: any) => {
        setTotalMedicinesNew([])
        console.log(err?.message)
      })
  }, [])


  useEffect(() => {

    if (order) {
      setInitialValue({
        ...initialValue,
        chemoOrderForDate: order.chemoOrderForDate,
        lineOfTreatment: order?.lineOfTreatment,
        chemoTemplate: order?.chemoTemplate,
        regimen: order?.regimen,
        cycleNo: order?.cycleNo,
        week: order?.week,
        day: order?.day,
        diagnosis: order?.diagnosis,
        ecogStatus: order?.ecogStatus,
        toxicity: order?.toxicity,
        sideEffects: order?.sideEffects,
        clinicalNotes: order?.clinicalNotes,
        followUpDate: order?.followUpDate,
        nextCycleOn: order?.nextCycleOn,
        cycleFrequency: order?.cycleFrequency,
        procedureNotes: order?.procedureNotes,
        takenOutside: order?.takenOutside,
        consultantIdForApproval: order?.approvalDetails?.approverId

      })
      const newPreMedication = order?.preMedications;
      const tempPre = newPreMedication ?
        Array.isArray(newPreMedication) ?
          newPreMedication?.length > 0 ? [...newPreMedication] : [preMedication]
          : []
        : [preMedication];
      const newChemotherapy = order?.chemotherapyAdministration;
      const tempChemo: any = newChemotherapy ?
        Array.isArray(newChemotherapy) ?
          newChemotherapy?.length > 0 ? [...newChemotherapy] : [chemotherapyAdministration]
          : []
        : [chemotherapyAdministration]
      const newTakeHome = order?.takeHomeMedicines;
      const tempTakeHome: any = newTakeHome ?
        Array.isArray(newTakeHome) ?
          newTakeHome?.length > 0 ? [...newTakeHome] : [takeHomeMedicine]
          : []
        : [takeHomeMedicine]

      const newTest = order?.testsToBeDone;

      //const tempTest: any = [...newTest]
      const tempTest: any = newTest ?
        Array.isArray(newTest) ?
          newTest?.length > 0 ? [...newTest] : [testRequired]
          : []
        : [testRequired]


      setPreMedicationInfo(tempPre)
      setChemotherapyInfo(tempChemo);
      setTakeHomeMedicineInfo(tempTakeHome);
      setTestRequiredInfo(tempTest);
      updateSelectedInputValues(tempPre, tempChemo, tempTakeHome)
    }
    else {
      setInitialValue({
        ...initialValue,
        diagnosis: diagnosisValues,
      })
    }

  }, [smartSummaryData])



  //Pre Medications and side Effects of pre medication
  const [preMedicationInfo, setPreMedicationInfo] = useState([preMedication]);
  const [totalMedicinesSide, setTotalMedicinesSide] = useState<any>({});
  const [totalMedicinesSideHome, setTotalMedicinesSideHome] = useState<any>({});
  const [renderKey, setRenderKey] = useState<any>(0);
  const [renderKeyChemo, setRenderKeyChemo] = useState<any>(0);
  const [renderKeyTake, setRenderKeyTake] = useState<any>(0);

  //Chemotherapy admininstration

  const [chemotherapyInfo, setChemotherapyInfo] = useState([chemotherapyAdministration]);


  const [chemo, setChemo] = useState<any>()

  //Take Home Medicines and side Effeccts of take home medicines
  const [takeHomeMedicineInfo, setTakeHomeMedicineInfo] = useState([takeHomeMedicine]);
  const [takeHomeState, setTakeHome] = useState<any>()
  const [sideEffectTakeHome, setSideEffectTakeHome] = useState<any>(false);

  //Test Required

  const [testRequiredInfo, setTestRequiredInfo] = useState([testRequired]);

  //Medicines List
  const [medicineOptions, updateMedicineOptions] = useState([])
  const [totalMedicines, updateTotalMedicines] = useState<any>()
  const [medicine, updateMedicine] = useState<any>("")

  //Tests List
  const [testsOptions, setTestsOptions] = useState<any>([])
  const testRefChemo = useRef<any>(null);


  //Regimen template editing and updating
  const [templates, setTemplates] = useState<any>([])
  const [orderTemplates, setOrderTemplates] = useState<any>([])
  const [updateTemplateList, setupdateTemplateList] = useState<boolean>(false)
  const userDetail = useSelector((state: any) => state?.user?.userDetail);
  const userRole = useSelector((state: any) => state?.user?.userDetail?.roles[0]);

  //Side Effects medicines



  useEffect(() => {
    const type = "CHEMO"
    const centerId = userDetail?.currentCenter?.centerId
    getListCancerTemplate(type, centerId)
      .then((res: any) => {
        setTemplates(res)
      })
      .catch((err: any) => {
        console.log(err)
      })
  }, [updateTemplateList])


  useEffect(() => {
    getListCancerOrder(patientInfo?.id)
      .then((res: any) => {
        setOrderTemplates(res)
      })
      .catch((err: any) => {
        console.log(err)
      })
  }, [])

  useEffect(() => {
    fetchMedicine(medicine)
  }, [medicine])

  useEffect(() => {
    const centerId = userDetail?.currentCenter?.centerId
    // const tempOptions = InitialValuesTestRequired?.map((each: any) => {
    //   return { label: each?.serviceName, value: each?.serviceId }
    // })

    // setTestsOptions(tempOptions)
    getTestsList(centerId)
      .then((res: any) => {
        const tempOptions = res?.map((each: any) => {
          return { label: each?.serviceName, value: each?.serviceId }
        })
        // const tempOptions = InitialValuesTestRequired?.map((each: any) => {
        //   return { label: each?.serviceName, value: each?.serviceId }
        // })

        setTestsOptions(tempOptions)

      })

  }, [])


  const dropdownCancerTemplates = templates.map((vals: any) => {
    return {
      label: vals?.subType ? vals?.subType : "Untitled template",
      value: vals?.id,
    }
  })

  const dropdownCancerOrder = orderTemplates.map((vals: any) => {
    return {
      label: `Cycle Number: ${vals?.cycleNo};  Date: ${vals?.chemoOrderForDate ? moment(vals?.chemoOrderForDate).format('DD/MM/YYYY') : 'Not available'}`,
      value: vals?.id
    }
  })



  function fetchMedicine(med: any) {
    getAllWondersoftDrugs()
      .then((res) => {
        updateTotalMedicines(res)
        const temp = res?.map((each: any) => ({
          label: each?.brandName,
          value: each?.id,
        }))
        const sortedTemp = temp?.sort((a: any, b: any) => {
          if (a?.label?.toLowerCase() < b?.label.toLowerCase()) {
            return -1
          }
          if (a?.label.toLowerCase() > b?.label.toLowerCase()) {
            return 1
          }
          return 0
        })
        if (medicine === "") {
          updateMedicineOptions(sortedTemp)
        } else {
          updateMedicineOptions(temp)
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  function handleSavePrescription(id: any, data: any, type: any) {
    data["isWondersoft"] = true
    data.medicines?.map(function (info: any) {
      delete info["typeOptions"]
    })
    let count;
    if (type === "PRE_MEDICATION") {
      count = preMedicationInfo?.length
    }
    else if (type === "CHEMOTHERAPY_ADMINISTRATION") {
      count = chemotherapyInfo?.length
    }
    else {
      count = takeHomeMedicineInfo?.length
    }
    console.log("handleSavePrescription ", data, count, order)
    setIsLoading(true)
    savePrescriptionChemoOrder(data, order?.id, type, count)
      .then((res: any) => {
        setIsLoading(false)
        toggleDisplayToast({ text: "Prescription saved Successfully", type: "success" })
        if (type === "PRE_MEDICATION") {
          setPreMedicationInfo(res?.preMedications)
          setRenderKey(renderKey + 1)
        }
        else if (type === "CHEMOTHERAPY_ADMINISTRATION") {
          setChemotherapyInfo(res?.chemotherapyAdministration)
          setRenderKeyChemo(renderKeyChemo + 1)
        }
        else {
          setTakeHomeMedicineInfo(res?.takeHomeMedicines)
          setRenderKeyTake(renderKeyTake + 1)
        }
      })
      .catch((err: any) => {
        setIsLoading(false)
        toggleDisplayToast({ text: `${err?.response?.data?.message}`, type: "error" })
        console.log(err?.response?.data?.message);
      })
  }

  function handleUpdatePrescription(id: any, data: any, type: any) {
    data["isWondersoft"] = true
    data.medicines?.map(function (info: any) {

      if (info.sideEffectCheck === false) {
        info.selectedSideEffects = []
      }

      delete info["typeOptions"]
    })
    // setIsLoading(true)
    // if (data?.isReadyToSent) {
    //   toggleDisplayToast({ text: "Prescription has already been Updated Before", type: 'warning' })
    // }
    updatePrescriptionChemoOrder(data, order?.id, type, id)
      .then((res: any) => {
        setIsLoading(false)
        toggleDisplayToast({ text: "Prescription updated Successfully", type: "success" })
        if (type === "PRE_MEDICATION") {
          setPreMedicationInfo(res?.preMedications)
          setRenderKey(renderKey + 1)
        }
        else if (type === "CHEMOTHERAPY_ADMINISTRATION") {
          setChemotherapyInfo(res?.chemotherapyAdministration)
          setRenderKeyChemo(renderKeyChemo + 1)
        }
        else {
          setTakeHomeMedicineInfo(res?.takeHomeMedicines)
          setRenderKeyTake(renderKeyTake + 1)
        }
      })
      .catch((err: any) => {
        setIsLoading(false)
        console.log(err?.message);
        toggleDisplayToast({ text: `${err?.response?.data?.message}`, type: "error" })
      })
  }

  function handleSendPrescription(id: any, data: any, type: any) {
    // setIsLoading(true)
    sendPrescriptionChemoOrderWondersoft(type, id, order.id)
      .then((res: any) => {
        setIsLoading(false)
        toggleDisplayToast({ text: "Prescription sent  Successfully", type: "success" })
        if (type === "PRE_MEDICATION") {
          setPreMedicationInfo(res?.preMedications)
        }
        else if (type === "CHEMOTHERAPY_ADMINISTRATION") {
          setChemotherapyInfo(res?.chemotherapyAdministration)
        }
        else {
          setTakeHomeMedicineInfo(res?.takeHomeMedicines)
        }
      })
      .catch((err: any) => {
        setIsLoading(false)
        toggleDisplayToast({ text: `${err?.response?.data?.message}`, type: "error" })
        console.log(err?.message)
      })
  }

  function handleSaveTest(data: any) {
    delete data["id"]
    delete data["integrationOrderId"]
    delete data["isCancelled"]
    delete data["isSent"]
    // setIsLoading(true)
    saveLabPrescriptionChemoOrder(data, order?.id, patientInfo?.id)
      .then((res: any) => {
        setIsLoading(false)
        toggleDisplayToast({ text: "Test saved  Successfully", type: "success" })
        setTestRequiredInfo(res?.testsToBeDone)
      })
      .catch((err: any) => {
        setIsLoading(false)
        toggleDisplayToast({ text: `${err?.response?.data?.message}`, type: "error" })
        console.log(err?.message)
      })
  }

  function handleUpdateTest(data: any) {
    // if (data?.isSent) {
    //   toggleDisplayToast({ text: "Prescription has already been Updated Before", type: 'warning' })
    // }

    const id = data["id"]
    delete data["id"]
    delete data["integrationOrderId"]
    delete data["isCancelled"]
    delete data["isSent"]
    // setIsLoading(true)



    updateLabPrescriptionChemoOrder(order?.id, id, data)
      .then((res: any) => {
        setIsLoading(false)
        toggleDisplayToast({ text: "Test updated  Successfully", type: "success" })
        setTestRequiredInfo(res?.testsToBeDone)
      })
      .catch((err: any) => {
        setIsLoading(false)
        toggleDisplayToast({ text: `${err?.response?.data?.message}`, type: "error" })
        console.log(err?.message)
      })
  }

  function handleSendTest(data: any) {
    const id = data["id"]
    // delete data["id"]
    // setIsLoading(true)
    sendLabPrescriptionChemoOrder(order?.id, id)
      .then((res: any) => {
        setIsLoading(false)
        toggleDisplayToast({ text: "Test Sent  Successfully", type: "success" })
        setTestRequiredInfo(res?.testsToBeDone)
      })
      .catch((err: any) => {
        setIsLoading(false)
        toggleDisplayToast({ text: `${err?.response?.data?.message}`, type: "error" })
        console.log(err?.message)
      })
  }

  function handleCancelTest(data: any) {

    const id = data["id"]
    //delete data["id"]
    // setIsLoading(true)
    cancelLabPrescriptionChemoOrder(order?.id, id)
      .then((res: any) => {
        setIsLoading(false)
        toggleDisplayToast({ text: "Test cancelled  Successfully", type: "success" })
        setTestRequiredInfo(res?.testsToBeDone)
      })
      .catch((err: any) => {
        console.log(err);
        setIsLoading(false)
        if (err?.response?.status == '403') {
          toggleDisplayToast({ text: `${err?.response?.data?.message}`, type: "error" })
        } else {
          toggleDisplayToast({ text: `Unable to cancel the Test`, type: "error" })
        }

        console.log(err?.message)
      })
  }

  //Dropdown values for type, frequencies ,dose
  const title = medicineTypeWS.map((ele: any) => {
    return { label: ele, value: ele }
  })

  const doses = DoseType.map((ele: any) => {
    return { label: ele, value: ele }
  })

  const whens = whenType.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const [frequencies, setFrequencies] = useState([]);

  useEffect(() => {
    const updatedFrequencies = freqDose?.map((ele: any) => {
      return { label: ele, value: ele };
    });
    setFrequencies(updatedFrequencies);
  }, [freqDose]);

  const [drugDosage, setDrugdosage] = useState<any>()
  const [showdrugValidation, setShowdrugvalidation] = useState(false)
  const fetchDosage = (drugId: any) => {
    getDrugById(drugId).then((res) => {
      setDrugdosage(res)
    })
  }


  const drugDosageValidation = (value: any) => {
    const numericValueDosage = parseFloat(drugDosage?.upperLimit?.match(/\d+/)[0]);
    const numericValue = parseFloat(value?.match(/\d+/)[0]);
    if (Object.keys(drugDosage).length > 0) {
      if (drugDosage?.upperLimit !== null && drugDosage?.lowerLimit !== null) {
        if (
          (numericValue > numericValueDosage)
        ) {
          setShowdrugvalidation(true)
        }
      }
    }
  }

  //Drug Interaction Validation
  //Popups
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState("")
  const [error, setError] = useState<boolean>(false)
  //Loader
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const checkDrugInteraction = (values: any, i: any) => {

    checkIcdDrugInteraction(values[i])
      .then((res: any) => {
        let msg = ''
        res?.fullInteractionTypeGroup[0]?.fullInteractionType.forEach((each: any) => msg += each?.comment)
        const temp = msg.split("asserted in DrugBank between")

        let displayText = ""
        for (let i = 1; i < temp.length; i += 2) {
          const parts = temp[i].split(".")
          displayText += `> Interaction found between${parts[0]}.\n`
        }
        if (displayText) {
          if (displayText.length > 0) {
            setMessage(displayText)
            setOpen(true)
          }
        }
      })
      .catch((err: any) => {
        console.log(err?.message)
      })
  }

  function onValueChangeDrug(source: any, medicationType: any, value: any, i: any, j: any, data?: any) {
    var values: any;

    // if (medicationType === "preMedication") {
    //   values = [...preMedicationInfo]
    // }
    // if (medicationType === 'takeHomeMedicine') {
    //   values = [...takeHomeMedicineInfo]
    // }
    // if (medicationType === 'chemotherapy') {
    //   values = [...chemotherapyInfo]
    // }

    // if (source === "medicineName") {
    //   if (values[i].medicines.length > 1) {
    //     checkDrugInteraction(values, i);
    //   }
    // }
  }


  const newMedicineState = {
    preMedication: {},
    chemotherapy: {},
    takeHomeMedicine: {}
  }
  const [newMedicine, setNewMedicine] = useState<any>(newMedicineState);
  const [medicineState, setMedicine] = useState<any>();


  //handle Change for Medicine
  const handleChange = (option: any, i: any, j: any, type: any) => {
    const updateMedicineInfo = (info: any, medicineName: string, value: any) => {
      console.log(">>> value in handle change", value)
      const values = [...info];
      values[i].medicines[j].medicineName = medicineName;
      values[i].medicines[j].type = value?.drugType === undefined ? "" : value?.drugType;
      //Setting new value in drug type
      //setTypeOptions(value?.drugType);
      values[i].medicines[j].typeOptions = value?.drugType ? [value?.drugType] : []
      values[i].medicines[j].wondersoftProductCode = value?.alternateProductCode
      return values;
    };

    if (!medicineOptions.some(medicine => medicine === option?.value)) {
      // For newly created medicine
      const value = totalMedicines.find((each: any) => each?.id === option?.value);

      if (type === "preMedication") {
        setPreMedicationInfo(updateMedicineInfo(preMedicationInfo, option?.label, value));
        onValueChangeDrug("medicineName", "preMedication", option?.label, i, j, value);
        setSideEffectsToEmptyPreMed(i, j);
      } else if (type === "chemotherapy") {
        setChemotherapyInfo(updateMedicineInfo(chemotherapyInfo, option?.label, value));
        onValueChangeDrug("medicineName", "chemotherapy", value?.brandName, i, j, value);
        setSideEffectsToEmptyChemo(i, j)
      } else if (type === "takeHomeMedicine") {
        setTakeHomeMedicineInfo(updateMedicineInfo(takeHomeMedicineInfo, option?.label, value));
        onValueChangeDrug("medicineName", "takeHomeMedicine", value?.brandName, i, j, value);
        setSideEffectsToEmptyTakehome(i, j)
      }
    } else {
      // For options created from dropdown
      const value = totalMedicines.find((each: any) => each?.id === option?.value);

      if (type === "preMedication") {
        setPreMedicationInfo(updateMedicineInfo(preMedicationInfo, value?.brandName, value));
        onValueChangeDrug("medicineName", "preMedication", value?.brandName, i, j, value);
      } else if (type === "chemotherapy") {
        setChemotherapyInfo(updateMedicineInfo(chemotherapyInfo, value?.brandName, value));
        onValueChangeDrug("medicineName", "chemotherapy", value?.brandName, i, j, value);
      } else if (type === "takeHomeMedicine") {
        setTakeHomeMedicineInfo(updateMedicineInfo(takeHomeMedicineInfo, value?.brandName, value));
        onValueChangeDrug("medicineName", "takeHomeMedicine", value?.brandName, i, j, value);
      }
    }

    const value = totalMedicines.find((each: any) => each?.id === option?.value);
    if (value) {

      fetchDosage(value?.id);
      getDrugById(value?.id)
        .then((res: any) => {
          setTotalMedicinesSide({
            ...totalMedicinesSide,
            [`${value?.brandName}`]: res
          });
        })
        .catch((err: any) => {
          console.log(err, "err");
        });
    }
  };

  //Handle Change for  Dose and frequency
  //handle Change for Medicine
  const handleChangeStandard = (option: any, i: any, j: any, type: any) => {

    if (type === "takeHomeMedicine") {
      const values = [...takeHomeMedicineInfo]
      values[i].medicines[j].when = option?.value
      setTakeHomeMedicineInfo([...values]);

    }
  };

  //Consultant Signature
  const templateJSON = {
    "logoPosition": "right",
    "pages": [
      {
        "name": "page1",
        "elements": [
          {
            "type": "signaturepad",
            "penColor": "black",
            "name": "consultantSign",
            "title": ".",
            "hideNumber": true
          },
        ]
      }
    ],
    "showNavigationButtons": "none",
    "showPageTitles": false,
    "showCompletedPage": false
  }


  const [selectedSign, setSelectedSign] = useState<any>()
  const [consultants, setConsultants] = useState<any>()
  const [consultantOptions, setConsultantOptions] = useState<any>([])
  const [signatureData, setSignatureData] = useState<any>({})
  const [signatureJson, setSignatureJson] = useState<any>(templateJSON)

  useEffect(() => {
    fetchConsultants()
  }, [])
  let valuesSign: any;
  useEffect(() => {
    if (valuesSign?.consultantSign) {
      const found = consultants?.find((each: any) => each?.signaturePicUrl === valuesSign?.consultantSign)
      if (found) {
        setSelectedSign(found?.name)
      }
    }
  }, [consultants, valuesSign])


  useEffect(() => {
    if (selectedSign) {
      const found = consultants?.find((ele: any) => ele?.name === selectedSign)
      if (found) {
        valuesSign = { ...signatureData }
        valuesSign["consultantSign"] = found?.signaturePicUrl
        setSignatureData(valuesSign)
      }
    }
  }, [consultants, selectedSign])

  const updateSurveyData = (data: any) => {
    setSignatureData(data)
  }

  function fetchConsultants() {

    getAllConsultants(`?primaryRole=CONSULTANT&centerId=${userDetail?.currentCenter?.centerId}`)
      .then((res: any) => {
        setConsultants(res)
        const temp = res.map((ele: any) => {
          return {
            label: ele?.name,
            value: ele?.id
          }
        })
        setConsultantOptions(temp)
      })
      .catch((err) => {
        console.log("Err", err)
      })
  }

  //Perform Null Check Function
  const performNullCheck = (data: any) => {
    const medicinesData = [...data];
    const filteredMedicines = medicinesData.filter((item) => {
      let objectItemCount = Object.keys(item).length;
      let count = 0;
      Object.keys(item).forEach((eachItem) => {
        if (item[eachItem] === "" || (Array.isArray(item[eachItem]) && item[eachItem].length === 0) || !item[eachItem]) {
          count++;
        }
      });
      return objectItemCount !== count;
    });
    return filteredMedicines;
  };


  function checkEmptyPreMedications(preMedications: any) {
    const isFieldEmpty = (value: any) => value === "" || (Array.isArray(value) && value.length === 0) || value === false || value === true;

    if (preMedications.every((item: any) => Object.values(item).every(isFieldEmpty))) {
      return null;
    }

    return preMedications;
  }



  //Saving chemo Order
  let temp: any[];
  //Maintaining State so that Save Chemo Order is not clicked multiple time
  const [disableChemoButton, setDisableChemoButton] = useState<any>(false);
  //State is being Called in Parent Component so that it can be redirected to Pending Order

  const saveChemoOrder = (() => {
    initialValue["patientId"] = patientInfo?.id;
    preMedicationInfo?.map(function (v: any) {
      v["isWondersoft"] = true
      v.medicines?.map(function (info: any) {
        delete v["addToPrint"];
        delete info["typeOptions"]
      })
    });
    chemotherapyInfo.map(function (v: any) {
      v["isWondersoft"] = true
      v.medicines?.map(function (info: any) {
        delete v["addToPrint"];
        delete info["typeOptions"]
      })
    });
    takeHomeMedicineInfo.map(function (v: any) {
      v["isWondersoft"] = true
      v.medicines?.map(function (info: any) {
        delete v["addToPrint"];
        delete info["typeOptions"]
      })
    });
    testRequiredInfo.map(function (v: any) {
      delete v["addToPrint"];
      delete v["isSent"];
      delete v["isCancelled"];
      delete v['id'];
      delete v['integrationOrderId'];
    });

    //Pre Medication
    let modifiedPreMedicationData = preMedicationInfo?.map((each) => {
      const { prescriptionDocument, ...rest } = each;
      const formatted = performNullCheck(each?.medicines);
      rest["medicines"] = formatted;
      return rest;
    });

    const nullCheckedPreMedication = checkEmptyPreMedications(modifiedPreMedicationData);


    //Chemotherapy
    let modifiedChemotherapyData = chemotherapyInfo?.map((each) => {
      const { prescriptionDocument, ...rest } = each;
      const formatted = performNullCheck(each?.medicines);
      rest["medicines"] = formatted;
      return rest;
    })

    const nullCheckedChemotherapy = checkEmptyPreMedications(modifiedChemotherapyData);


    //Take Home

    let modifiedTakeHomeData = takeHomeMedicineInfo?.map((each) => {
      const { prescriptionDocument, ...rest } = each;
      const formatted = performNullCheck(each?.medicines)
      rest["medicines"] = formatted
      return rest
    })
    const nullCheckedTakeHomeMedicine = checkEmptyPreMedications(modifiedTakeHomeData);

    //Test Required
    let modifiedTestRequired = testRequiredInfo?.map((each) => {
      const { prescriptionDocument, ...rest } = each;
      return rest
    })
    const nullCheckedTestRequired = checkEmptyPreMedications(modifiedTestRequired);


    initialValue["preMedications"] = nullCheckedPreMedication;
    initialValue["chemotherapyAdministration"] = nullCheckedChemotherapy;
    initialValue["takeHomeMedicines"] = nullCheckedTakeHomeMedicine;
    initialValue["testsToBeDone"] = modifiedTestRequired;

    let temp = { ...initialValue }
    const cycleNoValue = temp.cycleNo
    if (cycleNoValue === "") {
      setcycleNoError(true)
      return null
    }
    else {
      setDisableChemoButton(true);
      addChemoOrder(initialValue)
        .then((res) => {
          toggleDisplayToast({ text: "Chemo Order Created Successfully", type: "success" })
          setDisableChemoButton(false);
        })
        .catch((err) => {
          console.log("err", err)
          toggleDisplayToast({ text: "Unable to Create Chemo Order", type: "error" })
          setDisableChemoButton(false);
        })
    }

  })

  //Update chemo Order
  const updateOrders = (() => {
    initialValue["patientId"] = patientInfo?.id;
    preMedicationInfo.map(function (v: any) {
      v["isWondersoft"] = true
      v.medicines?.map(function (info: any) {
        if (info.sideEffectCheck === false) {
          info.selectedSideEffects = []
        }
        delete v["addToPrint"];
        delete info["typeOptions"]
      })
    });
    chemotherapyInfo.map(function (v: any) {
      v["isWondersoft"] = true
      v.medicines?.map(function (info: any) {
        if (info.sideEffectCheck === false) {
          info.selectedSideEffects = []
        }
        delete v["addToPrint"];
        delete info["typeOptions"]
      })
    });
    takeHomeMedicineInfo.map(function (v: any) {
      v["isWondersoft"] = true
      v.medicines?.map(function (info: any) {
        if (info.sideEffectCheck === false) {
          info.selectedSideEffects = []
        }
        delete v["addToPrint"];
        delete info["typeOptions"]
      })
    });
    testRequiredInfo.map(function (v: any) {
      v.medicines?.map(function (info: any) {
        delete v["addToPrint"];
        delete info["typeOptions"]
      })
    });

    //Performing Null CHeck

    //Pre Medication
    let modifiedPreMedicationData = preMedicationInfo?.map((each) => {
      const { prescriptionDocument, ...rest } = each;
      const formatted = performNullCheck(each?.medicines);
      rest["medicines"] = formatted;
      return rest;
    });

    const nullCheckedPreMedication = checkEmptyPreMedications(modifiedPreMedicationData);


    //Chemotherapy
    let modifiedChemotherapyData = chemotherapyInfo?.map((each) => {
      const { prescriptionDocument, ...rest } = each;
      const formatted = performNullCheck(each?.medicines);
      rest["medicines"] = formatted;
      return rest;
    })

    const nullCheckedChemotherapy = checkEmptyPreMedications(modifiedChemotherapyData);


    //Take Home

    let modifiedTakeHomeData = takeHomeMedicineInfo?.map((each) => {
      const { prescriptionDocument, ...rest } = each;
      const formatted = performNullCheck(each?.medicines)
      rest["medicines"] = formatted
      return rest
    })
    const nullCheckedTakeHomeMedicine = checkEmptyPreMedications(modifiedTakeHomeData);

    //Test Required
    let modifiedTestRequired = testRequiredInfo?.map((each) => {
      const { prescriptionDocument, ...rest } = each;
      // return { tests: each?.tests }
      return rest
    })

    const nullCheckedTestRequired = checkEmptyPreMedications(modifiedTestRequired);

    initialValue["preMedications"] = nullCheckedPreMedication;
    initialValue["chemotherapyAdministration"] = nullCheckedChemotherapy;
    initialValue["takeHomeMedicines"] = nullCheckedTakeHomeMedicine;
    initialValue["testsToBeDone"] = modifiedTestRequired

    delete initialValue['patientId']

    setDisableChemoButton(true);
    updateChemoOrder(initialValue, order?.therapyId, order?.id)
      .then((res) => {
        setDisableChemoButton(false);
        setIsLoading(false)
        toggleDisplayToast({ text: "Chemo Order Updated Successfully", type: "success" })
        handleChemoOrderUpdation(true);
        setPreMedicationInfo(res?.preMedications)
        setChemotherapyInfo(res?.chemotherapyAdministration)
        setTakeHomeMedicineInfo(res?.takeHomeMedicines)
        setTestRequiredInfo(res?.testsToBeDone)
        redirectPendingOrder(1);
      })
      .catch((err) => {
        console.log("err", err)
        setDisableChemoButton(false);
        setIsLoading(false)
        toggleDisplayToast({ text: "Unable to Update Chemo Order", type: "error" })
      })

  })
  //save regimen details
  function saveRegimenDetails() {
    if (initialValue?.regimen?.length > 0) {
      preMedicationInfo.map(function (v: any) {
        delete v["sideEffectPreMed"];
        delete v["addToPrint"]
      });
      takeHomeMedicineInfo.map(function (v: any) {
        // delete v["route"];
        delete v["sideEffectTakeHome"];
        delete v["addToPrint"]
      });
      testRequiredInfo.map(function (v: any) {
        delete v["addToPrint"];
      });

      const templateData = {
        type: "CHEMO",
        centers: [userDetail?.currentCenter?.centerId],
        subType: initialValue.regimen,
        data: [
          {
            json: {
              templateName: initialValue.regimen,
              preMedications: preMedicationInfo,
              chemotherapyAdministration: chemotherapyInfo,
              takeHomeMedicines: takeHomeMedicineInfo,
            }
          }
        ],
      }
      // setIsLoading(true)
      addNewCancerTemplate(templateData)
        .then((res: any) => {
          setIsLoading(false)
          setupdateTemplateList((current) => !current)
          toggleDisplayToast({ text: "New Template added Successfully", type: "success" })
        })
        .catch((err: any) => {
          console.log(err)
          setIsLoading(false)
          toggleDisplayToast({ text: "Unable to add new Template", type: "error" })
        })
    }
    else {
      toggleDisplayToast({ text: "Please enter Regimen Name", type: "error" })
    }
  }

  const convertToYYYYMMDD = (dateString: any) => {
    if (dateString) {
      const [day, month, year] = dateString.split('-');
      // Check if the date is in "DD-MM-YYYY" format
      if (day && month && year && day.length === 2 && month.length === 2 && year.length === 4) {
        return `${year}-${month}-${day}`;
      }
    }
    // Return the original string if it doesn't match the expected format
    return dateString;
  };

  const cycleNoInputRef = useRef<any>(null);
  useEffect(() => {
    // Scroll to the input element if there is a cycleNoError
    if (cycleNoError) {
      cycleNoInputRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, [cycleNoError]);

  const handleInputChange = (origin: any, i: any, j: any, value: any) => {
    const selected: any = { ...selectedInputValues }
    selected[origin][i]["medicines"][j] = value
    setSelectedInputValues(selected)
  };

  const handleInputChangeFreq = (origin: any, i: any, j: any, value: any) => {
    const selected: any = { ...selectedInputValues }
    selected[origin][i]["freq"][j] = value
    setSelectedInputValues(selected)
  };

  const handleBlur = (origin: any, i: any, j: any) => {
    handleInputChange(origin, i, j, "")
    const elements = document.querySelectorAll('.addNew-wrapper *');
    elements.forEach((element: any) => {
      if (typeof element.blur === 'function') {
        element.blur();
      }
    });
  };

  const handleBlurFreq = (origin: any, i: any, j: any) => {
    handleInputChangeFreq(origin, i, j, "")
    const elements = document.querySelectorAll('.addNew-wrapper *');
    elements.forEach((element: any) => {
      if (typeof element.blur === 'function') {
        element.blur();
      }
    });
  };

  const handleChangeDuration = (selectedOption: any) => {
    const inputValue = selectedOption ? selectedOption.value : '';
    setInputValue(inputValue);
    const number = parseInt(inputValue);

    if (!isNaN(number)) {
      const newOptions = [
        { value: `${number} mins`, label: `${number} mins` },
        { value: `${number} hours`, label: `${number} hours` },
        { value: `${number} days`, label: `${number} days` },
        { value: `${number} weeks`, label: `${number} weeks` },
        { value: `${number} months`, label: `${number} months` },
        { value: `${number} years`, label: `${number} years` }
      ];
      setOptions1(newOptions);
    } else if ("daily".includes(inputValue.toLowerCase())) {
      setOptions1([{ value: 'Daily', label: 'Daily' }])
    } else {
      // const newOptions1 = [
      //   { value: ` days`, label: `days` },
      //   { value: ` weeks`, label: ` weeks` },
      //   { value: ` months`, label: ` months` },
      //   { value: ` years`, label: ` years` }];
      setOptions1([]);
    }
  };

  const handleChangeDurationChemo = (selectedOption: any) => {
    const inputValue = selectedOption ? selectedOption.value : '';
    setInputValueChemo(inputValue);
    const number = parseInt(inputValue);

    if (!isNaN(number)) {
      const newOptions = [
        { value: `${number} mins`, label: `${number} mins` },
        { value: `${number} hours`, label: `${number} hours` },
        { value: `${number} days`, label: `${number} days` },
        { value: `${number} weeks`, label: `${number} weeks` },
        { value: `${number} months`, label: `${number} months` },
        { value: `${number} years`, label: `${number} years` }
      ];
      setOptions1Chemo(newOptions);
    } else if ("daily".includes(inputValue.toLowerCase())) {
      setOptions1Chemo([{ value: 'Daily', label: 'Daily' }])
    } else {
      // const newOptions1 = [
      //   { value: ` days`, label: `days` },
      //   { value: ` weeks`, label: ` weeks` },
      //   { value: ` months`, label: ` months` },
      //   { value: ` years`, label: ` years` }];
      setOptions1Chemo([]);
    }
  };

  const handleChangeDurationTake = (selectedOption: any) => {
    const inputValue = selectedOption ? selectedOption.value : '';
    setInputValueTake(inputValue);
    const number = parseInt(inputValue);

    if (!isNaN(number)) {
      const newOptions = [
        { value: `${number} mins`, label: `${number} mins` },
        { value: `${number} hours`, label: `${number} hours` },
        { value: `${number} days`, label: `${number} days` },
        { value: `${number} weeks`, label: `${number} weeks` },
        { value: `${number} months`, label: `${number} months` },
        { value: `${number} years`, label: `${number} years` }
      ];
      setOptionsTake(newOptions);
    } else if ("daily".includes(inputValue.toLowerCase())) {
      setOptionsTake([{ value: 'Daily', label: 'Daily' }])
    } else {
      // const newOptions1 = [
      //   { value: ` days`, label: `days` },
      //   { value: ` weeks`, label: ` weeks` },
      //   { value: ` months`, label: ` months` },
      //   { value: ` years`, label: ` years` }];
      setOptionsTake([]);
    }
  };


  const updateSelectedInputValues = (preMedicationInfo: any, chemotherapyInfo: any, takeHomeMedicineInfo: any) => {
    const temp = {
      preMedication: [],
      takeHome: [],
      chemotherapyAdministration: [],
      freq: []
    }
    const tempPreValues: any = preMedicationInfo?.map((each: any) => {
      const meds = each?.medicines?.map((m: any) => m?.medicineName)
      return {
        medicines: meds
      }
    })
    temp["preMedication"] = tempPreValues

    const tempChemoValues: any = chemotherapyInfo?.map((each: any) => {
      const meds = each?.medicines?.map((m: any) => m?.medicineName)
      return {
        medicines: meds
      }
    })
    temp["chemotherapyAdministration"] = tempChemoValues

    const tempTakeHomeValues: any = takeHomeMedicineInfo?.map((each: any) => {
      const meds = each?.medicines?.map((m: any) => m?.medicineName)
      return {
        medicines: meds
      }
    })
    temp["takeHome"] = tempTakeHomeValues

    const tempTakeHomeFreq: any = takeHomeMedicineInfo?.map((each: any) => {
      const freq = each?.medicines?.map((m: any) => m?.frequency)
      return {
        freq: freq
      }
    })
    temp["freq"] = tempTakeHomeFreq

    setSelectedInputValues(temp)
  }

  const handleDragEnd = (preMedIndex: any) => {
    const e = updatedDragEvent
    if (!e.destination) return
    let tempData = Array.from(medicineState?.medicines)
    let [source_data] = tempData.splice(e.source.index, 1)
    tempData.splice(e.destination.index, 0, source_data)
    medicineState["medicines"] = tempData
    const updatedArray = preMedicationInfo.map((item: any) => {
      if (item.id === medicineState.id) {
        return medicineState
      } else {
        return item
      }
    })
    setPreMedicationInfo(updatedArray)
    handleMedNameChange("preMedication", preMedIndex, e.source.index, e.destination.index)
    setUpdatedDragEvent(null)
  };

  const handleDragEndChemo = (chemoIndex: any) => {
    const e = updatedDragEvent
    if (!e.destination) return
    let tempData = Array.from(chemo?.medicines)
    let [source_data] = tempData.splice(e.source.index, 1)
    tempData.splice(e.destination.index, 0, source_data)
    chemo["medicines"] = tempData
    const updatedArray = chemotherapyInfo.map((item: any) => {
      if (item.id === chemo.id) {
        return chemo
      } else {
        return item
      }
    })
    setChemotherapyInfo(updatedArray)
    handleMedNameChange("chemotherapyAdministration", chemoIndex, e.source.index, e.destination.index)
    setUpdatedDragEvent(null)
  };

  const handleDragEndTakeHome = (takeHomeIndex: any) => {
    const e = updatedDragEvent
    if (!e.destination) return
    let tempData = Array.from(takeHomeState?.medicines)
    let [source_data] = tempData.splice(e.source.index, 1)
    tempData.splice(e.destination.index, 0, source_data)
    takeHomeState["medicines"] = tempData
    const updatedArray = takeHomeMedicineInfo.map((item: any) => {
      if (item.id === takeHomeState.id) {
        return takeHomeState
      } else {
        return item
      }
    })
    setTakeHomeMedicineInfo(updatedArray)
    handleMedNameChange("takeHome", takeHomeIndex, e.source.index, e.destination.index)
    handleFreqChange(takeHomeIndex, e.source.index, e.destination.index)
    setUpdatedDragEvent(null)
  };

  const handleMedNameChange = (origin: any, i: any, sourceIndex: any, destinationIndex: any) => {
    const selected: any = { ...selectedInputValues }
    let source_data = selected[origin][i]["medicines"].splice(sourceIndex, 1)
    selected[origin][i]["medicines"].splice(destinationIndex, 0, source_data[0])
    setSelectedInputValues(selected)
  }

  const handleFreqChange = (i: any, sourceIndex: any, destinationIndex: any) => {
    const selected: any = { ...selectedInputValues }
    let source_freq = selected["freq"][i]["freq"].splice(sourceIndex, 1)
    selected["freq"][i]["freq"].splice(destinationIndex, 0, source_freq[0])
    setSelectedInputValues(selected)
  }

  const handleCancel = () => {
    console.log("Cancel action");
    setShowToast(false);
  };

  const handleConfirm = () => {
    const updatedFreq = [...freqDose]
    updatedFreq.push(selectedFreq);
    updateFrequencies(`${userDetail?.currentCenter?.centerId}`, updatedFreq)
      .then((res: any) => {
        toggleDisplayToast({ text: "Frequency values successfully updated for the center", type: "success" });
        setFreqDose(res)
      })
      .catch((err: any) => {
        toggleDisplayToast({ text: "Cannot update the frequency values for the given center", type: "error" });
      });
    console.log("Confirm action");
    setShowToast(false);
  };

  const setSideEffectsToEmptyPreMed = (i: any, j: any) => {
    const updatedArray: any = preMedicationInfo.map((item: any, index: any) => {
      if (i === index) {
        const updatedMedicines = item.medicines.map((medicine: any, medIndex: any) => {
          if (j === medIndex) {
            return { ...medicine, selectedSideEffects: [] };
          } else {
            return medicine;
          }
        });
        return { ...item, medicines: updatedMedicines };
      } else {
        return item;
      }
    });

    setPreMedicationInfo(updatedArray)
  }

  const setSideEffectsToEmptyChemo = (i: any, j: any) => {
    const updatedArray: any = chemotherapyInfo.map((item: any, index: any) => {
      if (i === index) {
        const updatedMedicines = item.medicines.map((medicine: any, medIndex: any) => {
          if (j === medIndex) {
            return { ...medicine, selectedSideEffects: [] };
          } else {
            return medicine;
          }
        });
        return { ...item, medicines: updatedMedicines };
      } else {
        return item;
      }
    });

    setChemotherapyInfo(updatedArray)
  }

  const setSideEffectsToEmptyTakehome = (i: any, j: any) => {
    const updatedArray: any = takeHomeMedicineInfo.map((item: any, index: any) => {
      if (i === index) {
        const updatedMedicines = item.medicines.map((medicine: any, medIndex: any) => {
          if (j === medIndex) {
            return { ...medicine, selectedSideEffects: [] };
          } else {
            return medicine;
          }
        });
        return { ...item, medicines: updatedMedicines };
      } else {
        return item;
      }
    });

    setTakeHomeMedicineInfo(updatedArray)
  }

  const adjustTextareaHeight = () => {
    const textareas = document.getElementsByClassName('autoHeightTextarea') as HTMLCollectionOf<HTMLTextAreaElement>;
    Array.from(textareas).forEach(textarea => {
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
    });
  };

  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      border: "1px solid #ccd0e7",
      borderRadius: "10px",
      fontWeight: 700
    }),
    option: (provided: any) => ({
      ...provided,
      fontWeight: 700
    })
  };

  return (
    <div style={readOnly ? { cursor: 'not-allowed' } : {}} className="addNew-wrapper">
      {showToast && (
        <Toast
          textMessage="Do you want to save this frequency value for future use?"
          onCloseText="Cancel"
          onClickText="Confirm"
          onClose={handleCancel}
          onClick={handleConfirm}
          type="confirmation"
          textarea={false}
          textareaContent={null}
        />
      )}
      <div className="template-row-og mt-4">
        <div className='style-column' style={{ display: pendingOrDelete && "none" }}>
          <label style={{ marginBottom: "10px" }}>Load Previous Chemo Order</label>
          <Select
            defaultValue={{
              label: "",
              value: ""
            }}
            styles={customStyles}

            value={{
              label: selectedOptionLoadChemo?.label,
              value: selectedOptionLoadChemo?.value
            }}

            options={dropdownCancerOrder}
            onChange={(evnt: any) => {
              const templateName = evnt?.value
              setSelectedOptionLoadChemo(evnt)
              getSelectedChemoOrder(templateName)
                .then((res) => {
                  // setInitialValue({ ...initialValue, chemoTemplate: res?.templateName })
                  setInitialValue({
                    ...initialValue, regimen: res?.regimen,
                    chemoTemplate: res?.templateName
                  })

                  let tempFormattedPre: any = [];
                  const newPreMedication = res?.preMedications ? res?.preMedications : [preMedication];
                  if (newPreMedication) {
                    tempFormattedPre = [...newPreMedication];
                  }

                  let tempFormattedChemo: any = [];
                  const newChemotherapy = res?.chemotherapyAdministration ? res?.chemotherapyAdministration : [chemotherapyAdministration];
                  if (newChemotherapy) {
                    tempFormattedChemo = [...newChemotherapy]
                  }

                  let tempFormattedTakeHome: any = [];
                  const newTakeHome = res?.takeHomeMedicines ? res?.takeHomeMedicines : [takeHomeMedicine];
                  if (newTakeHome) {
                    tempFormattedTakeHome = [...newTakeHome]
                  }

                  setPreMedicationInfo(tempFormattedPre);
                  setTakeHomeMedicineInfo(tempFormattedTakeHome);
                  setChemotherapyInfo(tempFormattedChemo);
                  const formattedTestsToBeDone = res?.testsToBeDone.map((item: any) => {
                    return {
                      ...item,
                      tests: item.tests.map((each: any) => ({
                        ...each,
                        when: each.when !== "" ? "" : each.when
                      }))
                    };
                  });
                  setTestRequiredInfo(formattedTestsToBeDone);
                  updateSelectedInputValues(tempFormattedPre, tempFormattedChemo, tempFormattedTakeHome)
                  setRenderKey(renderKey + 1)
                  setRenderKeyChemo(renderKeyChemo + 1)
                  setRenderKeyTake(renderKeyTake + 1)
                })
                .catch((error: any) => {
                  console.log(error)
                })

            }}
            isDisabled={readOnly}
          />
        </div>
        <div
          className="date-wrapper-mui"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <label>Create chemo order for Date</label>
          <input
            type="date"
            className={`custom-input ${readOnly ? "read-only" : ""}`}
            name="chemoOrderForDate"
            value={initialValue.chemoOrderForDate}
            onChange={(e: any) => {
              setInitialValue({ ...initialValue, chemoOrderForDate: e.target.value })
            }}
            disabled={readOnly}

          />

        </div>

        <div className="checkbox-outside">
          <label>
            <input
              style={{ marginRight: '10px' }}
              type="checkbox"
              name="takenOutside"
              checked={initialValue.takenOutside}
              value={initialValue.takenOutside}
              onChange={(e) => {

                setInitialValue({ ...initialValue, takenOutside: e.target.checked })
              }}
              disabled={readOnly}
            />
            Chemo Order Completed Outside MOC
          </label>
          <input
            type="text"
            className={`custom-input ${readOnly ? "read-only" : ""}`}
            disabled={initialValue.takenOutside ? false : true || readOnly}
            value={initialValue.locationDetails}
            name="locationDetails"
            onChange={(e: any) => {
              setInitialValue({ ...initialValue, locationDetails: e.target.value })
            }}

          />
        </div>
      </div>
      <hr></hr>
      <div className="template-row">
        <div className='style-column'>
          <label>Load a chemo Template</label>
          <Select
            defaultValue={{
              label: "",
              value: ""
            }}

            styles={{
              control: (provided, state) => ({
                ...provided,
                border: "1px solid #ccd0e7",
                borderRadius: "10px",
                marginTop: "10px",
              })
            }}

            value={{
              label: initialValue?.chemoTemplate,
              value: initialValue?.chemoTemplate
            }}

            options={dropdownCancerTemplates}
            onChange={(evnt: any) => {
              setSelectedOptionLoadChemo('')
              const templateName = evnt?.value
              getDataCancerTemplate("CHEMO", templateName)
                .then((res) => {
                  // setInitialValue({ ...initialValue, chemoTemplate: res?.templateName })
                  setInitialValue({
                    ...initialValue, regimen: res?.templateName,
                    chemoTemplate: res?.templateName
                  })

                  const newPreMedication = res?.preMedications;
                  const tempPre: any = [...newPreMedication]

                  const newChemotherapy = res?.chemotherapyAdministration;
                  const tempChemo: any = [...newChemotherapy]

                  const newTakeHome = res?.takeHomeMedicines;
                  const tempTakeHome: any = [...newTakeHome]

                  setPreMedicationInfo(tempPre);
                  setTakeHomeMedicineInfo(tempTakeHome);
                  setChemotherapyInfo(tempChemo);
                  updateSelectedInputValues(tempPre, tempChemo, tempTakeHome)
                  setRenderKey(renderKey + 1)
                  setRenderKeyChemo(renderKeyChemo + 1)
                  setRenderKeyTake(renderKeyTake + 1)
                })
                .catch((error: any) => {
                  console.log(error)
                })

            }}
            isDisabled={readOnly}
          />
        </div>
        <div className='style-column'>
          <label>Line of Treatment</label>
          <input
            type="text"
            className={`custom-input ${readOnly ? "read-only" : ""}`}
            value={initialValue.lineOfTreatment}
            name="lineOfTreatment"
            onChange={(e: any) => {
              setInitialValue({ ...initialValue, lineOfTreatment: e.target.value })
            }}
            disabled={readOnly}
          />
        </div>
        {readOnly ? (<Button
          className="regimen-button"
          variant="primary"
          disabled
          onClick={() => {
            saveRegimenDetails()
          }}
        >
          Save as new regimen template
        </Button>) : (<Button
          className="regimen-button"
          variant="primary"
          onClick={() => {
            saveRegimenDetails()
            //saveRegimenDetails(values)
          }}
        >
          Save as new regimen template
        </Button>)}
      </div>
      <div className="regimen-row">
        <div className='style-column'>
          <label>Regimen</label>
          <input
            type="text"
            className={`custom-input ${readOnly ? "read-only" : ""}`}
            value={initialValue.regimen}
            name="regimen"
            onChange={(e: any) => {
              setInitialValue({ ...initialValue, regimen: e.target.value })
            }}
            disabled={readOnly}
          />
        </div>

        <div className='style-column'>
          {cycleNoError === false ? (<div style={{
            color: 'red', width: '20px',

            height: '5px', marginLeft: '-5px'
          }}>*</div>) : (<div></div>)}
          <label>Cycle No</label>
          <input
            type="text"
            ref={cycleNoInputRef}
            className={`custom-input ${readOnly ? "read-only" : ""}`}
            value={initialValue?.cycleNo}
            onChange={(e) => {
              function isValidNumber(str: any) {
                return !isNaN(str);
              }

              const inputValue = e.target.value;
              if (isValidNumber(inputValue)) {
                setInitialValue({ ...initialValue, cycleNo: inputValue });
              }
              else {
                setInitialValue({ ...initialValue, cycleNo: "0" });
              }
            }}

            disabled={readOnly}

          />


          {cycleNoError === true ? (<div style={{ color: 'red' }}>Cycle No. is Required</div>) : (<div></div>)}
        </div>


        <div className='style-column'>
          <label>Week</label>
          <input
            type="number"
            className={`custom-input ${readOnly ? "read-only" : ""}`}
            name="week"
            value={initialValue.week}
            onChange={(e: any) => {
              setInitialValue({ ...initialValue, week: e.target.value })
            }}
            disabled={readOnly}
          />
        </div>
        <div className='style-column'>
          <label>Day</label>

          <input
            type="number"
            className={`custom-input ${readOnly ? "read-only" : ""}`}
            name="day"
            value={initialValue.day}
            onChange={(e: any) => {
              setInitialValue({ ...initialValue, day: e.target.value })
            }}
            disabled={readOnly}
          />
        </div>
      </div>
      <hr></hr>
      <div className="diagnosis-row">
        <div className='style-column'>
          <label>Diagnosis</label>
          <input
            type="text"
            className={`custom-input ${readOnly ? "read-only" : ""}`}
            name="diagnosis"
            value={initialValue.diagnosis}
            onChange={(e: any) => {
              //initialValue.diagnosis.push(e.target.value);
              //setInitialValue({ ...initialValue, diagnosis: e.target.value })
            }}
            disabled={readOnly}
          />
        </div>
        <div className='style-column'>
          <label>ECOG PS</label>

          <Select
            defaultValue={{
              label: "",
              value: ""
            }}
            styles={{
              control: (provided, state) => ({
                ...provided,
                border: "1px solid #ccd0e7",
                borderRadius: "10px"
              })
            }}

            value={{
              label: initialValue.ecogStatus,
              value: initialValue.ecogStatus
            }}
            options={ecogOptions}
            onChange={(evnt: any) => {
              const numericPart = evnt?.label?.match(/^\d+/);
              if (numericPart) {
                // Extracted numeric part
                const numericValue = numericPart[0];
                setInitialValue({ ...initialValue, ecogStatus: numericValue })
              }

            }}
            isDisabled={readOnly}
          />
        </div>
      </div>

      <div className="tolerance-row">
        <div className='style-column'>
          <label>Toxicity</label>
          <input
            type="text"
            className={`custom-input ${readOnly ? "read-only" : ""}`}
            name="toxicity"
            value={initialValue.toxicity}
            onChange={(e: any) => {
              setInitialValue({ ...initialValue, toxicity: e.target.value })
            }}
            disabled={readOnly}
          />
        </div>
        <div className='style-column'>
          <label>Side Effects</label>
          <input
            type="text"
            className={`custom-input ${readOnly ? "read-only" : ""}`}
            name="sideEffects"
            value={initialValue.sideEffects}
            onChange={(e: any) => {
              setInitialValue({ ...initialValue, sideEffects: e.target.value })
            }}
            disabled={readOnly}
          />
        </div>
      </div>

      {/* PreMedication */}
      <div className="wrapper">
        <div className="">
          <div className='prescription-flex'>
            {

              !readOnly && (
                <div
                  style={{ marginLeft: '8px', marginBottom: '10px' }}
                  className={`add-new-button-prescription ${!preMedicationInfo || preMedicationInfo.length === 0 || !preMedicationInfo[preMedicationInfo.length - 1]?.readyToSent ? 'test-none' : ''}`}
                  onClick={() => {
                    const values = [...preMedicationInfo];
                    values.push({ ...preMedication });
                    setPreMedicationInfo([...values]);
                    updateSelectedInputValues([...values], chemotherapyInfo, takeHomeMedicineInfo)
                  }}
                >
                  Add New Prescription
                </div>
              )
            }

            {
              !readOnly && (
                <div>
                  <div className='m-3'>
                    <Print
                      componentRef={componentRef}
                      buttonTitle='Print Prescription'
                    />
                  </div>
                </div>
              )
            }
            <div>

            </div>

          </div>

          <div key={renderKey}>
            {preMedicationInfo?.map((val, i) => {
              return <div>
                <div className="dynamic-col-premedication">
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex' }}>
                      <label>Pre Medication</label>
                      {
                        preMedicationInfo?.length > 1 ?
                          (!readOnly && (
                            <div
                              style={{ marginLeft: '10px' }}
                              className="delete-icon"
                              onClick={() => {
                                if (preMedicationInfo?.length > 1) {
                                  const values = [...preMedicationInfo]
                                  values.splice(i, 1)
                                  setPreMedicationInfo(values)
                                  updateSelectedInputValues(values, chemotherapyInfo, takeHomeMedicineInfo)
                                }
                              }}
                            >
                              <img
                                src="../../../../assets/images/delete-icon.svg"
                                alt=""
                              />
                            </div>
                          )
                          ) : (
                            !readOnly && (
                              <div
                                style={{ marginLeft: '10px', cursor: "not-allowed" }}
                                className="delete-icon"
                              >
                                <img
                                  src="../../../../assets/images/delete-icon.svg"
                                  alt=""
                                />
                              </div>
                            )
                          )
                      }
                    </div>
                  </div>
                  <div className="table-heading-pre">
                    <div className="pre-subHeading">Sr.no</div>
                    <div className="pre-subHeading">Type</div>
                    <div className="pre-subHeading">Medicine</div>
                    <div className="pre-subHeading">Dose</div>
                    <div className="pre-subHeading" >When</div>
                    <div className="pre-subHeading">Route</div>
                    <div className="pre-subHeading">Notes/Instructions</div>
                    <div className="pre-subHeading" >Duration</div>
                    <div className="pre-subHeading">Side Effects</div>
                  </div>
                </div>
                <DragDropContext
                  onDragUpdate={(e: any) => { setUpdatedDragEvent(e); setMedicine(val); }}
                  onDragEnd={() => handleDragEnd(i)}>
                  <Droppable droppableId="id-0013" isDropDisabled={false}>
                    {(provider: any) => (
                      <div className="dynamic-col" ref={provider.innerRef}
                        {...provider.droppableProps}>
                        {val?.medicines?.map((item: any, j: any) => {

                          return (
                            <Draggable
                              key={`id_${j}`}
                              draggableId={`id_${j}`}
                              index={j}
                            >
                              {(provider: any) => (
                                <PreMedicationRow
                                  provider={provider}
                                  preMedicationInfo={preMedicationInfo}
                                  readOnly={readOnly}
                                  appointmentDetails={appointmentDetails}
                                  order={order}
                                  i={i}
                                  j={j}
                                  setPreMedicationInfo={setPreMedicationInfo}
                                  selectedInputValues={selectedInputValues}
                                  title={title}
                                  handleBlur={handleBlur}
                                  newMedicine={newMedicine}
                                  setSelectedInputValues={setSelectedInputValues}
                                  handleInputChange={handleInputChange}
                                  adjustTextareaHeight={adjustTextareaHeight}
                                  handleChangeDuration={handleChangeDuration}
                                  setInputValue={setInputValue}
                                  options1={options1}
                                  handleChange={handleChange}
                                  allDrugs={totalMedicines}
                                />

                              )}
                            </Draggable>
                          )
                        })}

                        {
                          !readOnly && (
                            <button
                              style={{}}
                              className="add-new-button"
                              onClick={() => {
                                const values: any = [...preMedicationInfo]
                                values[i].medicines.push(preMedicationMedicine)
                                setPreMedicationInfo([...values])

                                const selected: any = { ...selectedInputValues }
                                selected["preMedication"][i]["medicines"].push("")
                                setSelectedInputValues(selected)
                              }}
                              disabled={preMedicationInfo[i]?.isCancelled ? true : false || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
                            >
                              Add New
                            </button>
                          )
                        }

                        <div className="link cursor-pointer"
                          onClick={() => {
                            const values = [...preMedicationInfo]
                            values[i].sideEffectPreMed = !values[i].sideEffectPreMed;
                            setPreMedicationInfo([...values]);
                          }}
                        >Show Side Effects</div>

                        {preMedicationInfo[i].sideEffectPreMed ? <>
                          <SideEffectsWS
                            onValueChange={(data: any, i: any, j: any) => {
                              const values = [...preMedicationInfo]
                              values[i].medicines[j].selectedSideEffects = data;
                              setPreMedicationInfo([...values]);

                            }}
                            allMedicinesSideEffect={totalMedicinesNew}
                            index={i}
                            values={preMedicationInfo}
                            dropdown={totalMedicinesSide}
                            readOnly={readOnly}
                            appointmentDetails={appointmentDetails}
                            order={order}
                          />
                        </> : <></>}

                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
                {isEditableOrder ? <>
                  <div className="save-cancel-send">
                    <Button
                      onClick={() => {
                        if (!val["id"]) {
                          handleSavePrescription(preMedicationInfo[i].prescriptionId, preMedicationInfo[i], "PRE_MEDICATION")
                        }
                        else {

                          if (preMedicationInfo[i]?.readyToSent) {
                            toggleDisplayToast({
                              text: "Prescription cannot be resent to Wondersoft as it was already sent once. The updated prescription will only be available in the MOC Application", type: 'warning',
                              onUpdate: true,
                              handleUpdatePrescription: () => handleUpdatePrescription(preMedicationInfo[i].prescriptionId, preMedicationInfo[i], "PRE_MEDICATION")
                            })
                          }
                          else {
                            handleUpdatePrescription(preMedicationInfo[i].prescriptionId, preMedicationInfo[i], "PRE_MEDICATION")
                          }
                        }

                      }}
                      disabled={preMedicationInfo[i]?.isCancelled ? true : false || !preMedicationInfo[i]?.medicines[0]?.medicineName || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
                      variant="primary"

                    >
                      {!val["id"] ? "Save" : "Update"}
                    </Button>
                    <Button
                      onClick={() => {
                        handleSendPrescription(preMedicationInfo[i].prescriptionId, preMedicationInfo[i], "PRE_MEDICATION")
                      }}
                      disabled={preMedicationInfo[i]?.readyToSent ? true : false || !val["id"] || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
                      variant="primary"

                    >
                      Send
                    </Button>
                    {/* <Button
                      onClick={() => {
                        //saveChemoOrder(values)
                        handleCancelPrescription(preMedicationInfo[i].prescriptionId, preMedicationInfo[i], "PRE_MEDICATION")
                      }}
                      variant="primary"
                      disabled={preMedicationInfo[i].isCancelled || !preMedicationInfo[i]?.readyToSent ? true : false || readOnly}
                    >
                      Cancel
                    </Button> */}

                  </div>
                </> : <></>}
              </div>

            })}
          </div>




        </div>
      </div>


      {/* Chemotherapy Administration */}
      <div className="wrapper">
        <div className="">
          <div className='prescription-flex'>
            {
              !readOnly && (
                <div
                  style={{ marginLeft: '8px', marginBottom: '10px' }}
                  className={`add-new-button-prescription ${(!chemotherapyInfo || chemotherapyInfo.length === 0 || !chemotherapyInfo[chemotherapyInfo.length - 1]?.readyToSent) ? 'test-none' : ''}`}
                  onClick={() => {
                    const values = [...chemotherapyInfo];
                    values.push(chemotherapyAdministration);
                    setChemotherapyInfo([...values]);
                    updateSelectedInputValues(preMedicationInfo, [...values], takeHomeMedicineInfo)
                  }}
                >
                  Add New Prescription
                </div>
              )
            }
            {
              !readOnly && (
                <div>
                  <div className='m-3'>
                    <Print
                      componentRef={componentRef}
                      buttonTitle='Print Prescription'
                    />
                  </div>
                </div>
              )
            }
            <div>
            </div>

          </div>

          <div key={renderKeyChemo}>
            {chemotherapyInfo?.map((val, i) => {
              return <div>
                <div className="dynamic-col-premedication">
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex' }}>
                      <label>Chemotherapy Administration</label>
                      {chemotherapyInfo.length > 1 ? (
                        !readOnly && (
                          <div
                            style={{ marginLeft: '10px' }}
                            className="delete-icon"
                            onClick={() => {
                              if (chemotherapyInfo.length > 1) {
                                const values = [...chemotherapyInfo]
                                values.splice(i, 1)
                                setChemotherapyInfo(values)
                                updateSelectedInputValues(preMedicationInfo, values, takeHomeMedicineInfo)
                              }
                            }}
                          >
                            <img
                              src="../../../../assets/images/delete-icon.svg"
                              alt=""
                            />
                          </div>
                        )) : (
                        !readOnly && (
                          <div
                            style={{ marginLeft: '10px', cursor: "not-allowed" }}
                            className="delete-icon"
                          >
                            <img
                              src="../../../../assets/images/delete-icon.svg"
                              alt=""
                            />
                          </div>
                        )
                      )
                      }
                    </div>
                  </div>
                  <div className="table-heading-pre-chemo">
                    <div className="pre-subHeading">Sr.no</div>
                    <div className="pre-subHeading">Type</div>
                    <div className="pre-subHeading">Medicine</div>
                    <div className="pre-subHeading">Standard <br />Dose</div>
                    <div className="pre-subHeading">Dose</div>
                    <div className="pre-subHeading" style={{ marginLeft: '30px !important' }}>Dose Modification</div>
                    <div className="pre-subHeading">Route</div>
                    <div className="pre-subHeading" style={{ marginLeft: '40px !important' }}>
                      Notes/<br />
                      Instruction
                    </div>

                    <div className="pre-subHeading">Duration</div>
                    <div className="pre-subHeading">Side Effects</div>
                  </div>
                </div>

                <DragDropContext
                  onDragUpdate={(e: any) => { setUpdatedDragEvent(e); setChemo(val); }}
                  onDragEnd={() => handleDragEndChemo(i)}>
                  <Droppable droppableId="id-0014" isDropDisabled={false}>
                    {(provider: any) => (
                      <div className="dynamic-col" ref={provider.innerRef}
                        {...provider.droppableProps}>
                        {val?.medicines?.map((item, j) => {
                          return (
                            <Draggable
                              key={`id_${j}`}
                              draggableId={`id_${j}`}
                              index={j}
                            >
                              {(provider: any) => (
                                <>
                                  <ChemotherapyRow
                                    provider={provider}
                                    chemotherapyInfo={chemotherapyInfo}
                                    readOnly={readOnly}
                                    appointmentDetails={appointmentDetails}
                                    order={order}
                                    i={i}
                                    j={j}
                                    setChemotherapyInfo={setChemotherapyInfo}
                                    selectedInputValues={selectedInputValues}
                                    title={title}
                                    handleBlur={handleBlur}
                                    newMedicine={newMedicine}
                                    setSelectedInputValues={setSelectedInputValues}
                                    handleInputChange={handleInputChange}
                                    adjustTextareaHeight={adjustTextareaHeight}
                                    handleChangeDuration={handleChangeDuration}
                                    setInputValue={setInputValue}
                                    options1={options1}
                                    handleChange={handleChange}
                                    allDrugs={totalMedicines}
                                    options1Chemo={options1Chemo}
                                    handleChangeDurationChemo={handleChangeDurationChemo}
                                    setInputValueChemo={setInputValueChemo}
                                  />
                                </>
                              )}
                            </Draggable>
                          )
                        })}

                        {
                          !readOnly && (
                            <button
                              style={{}}
                              className="add-new-button"
                              onClick={() => {
                                const values: any = [...chemotherapyInfo]
                                values[i].medicines.push(chemotherapy)
                                setChemotherapyInfo([...values])

                                const selected: any = { ...selectedInputValues }
                                selected["chemotherapyAdministration"][i]["medicines"].push("")
                                setSelectedInputValues(selected)
                              }}
                              disabled={chemotherapyInfo[i]?.isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
                            >
                              Add New
                            </button>
                          )
                        }

                        <div className="link cursor-pointer"
                          onClick={() => {
                            const values = [...chemotherapyInfo]
                            values[i].sideEffectPreMed = !values[i].sideEffectPreMed;
                            setChemotherapyInfo([...values]);
                          }}
                        >Show Side Effects</div>

                        {chemotherapyInfo[i].sideEffectPreMed ? <>
                          <SideEffectsWS
                            onValueChange={(data: any, i: any, j: any) => {
                              const values = [...chemotherapyInfo]
                              values[i].medicines[j].selectedSideEffects = data;
                              setChemotherapyInfo([...values]);

                            }}
                            allMedicinesSideEffect={totalMedicinesNew}
                            index={i}
                            values={chemotherapyInfo}
                            dropdown={totalMedicinesSide}
                            readOnly={readOnly}
                            appointmentDetails={appointmentDetails}
                            order={order}
                          />
                        </> : <></>}

                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
                {isEditableOrder ? <>
                  <div className="save-cancel-send">
                    <Button
                      onClick={() => {
                        if (!val["id"]) {
                          handleSavePrescription(chemotherapyInfo[i].prescriptionId, chemotherapyInfo[i], "CHEMOTHERAPY_ADMINISTRATION")
                        }
                        else {

                          if (chemotherapyInfo[i]?.readyToSent) {
                            toggleDisplayToast({
                              text: "Prescription cannot be resent to Wondersoft as it was already sent once. The updated prescription will only be available in the MOC Application", type: 'warning',
                              onUpdate: true,
                              handleUpdatePrescription: () => handleUpdatePrescription(chemotherapyInfo[i].prescriptionId, chemotherapyInfo[i], "CHEMOTHERAPY_ADMINISTRATION")
                            })

                          }
                          else {
                            handleUpdatePrescription(chemotherapyInfo[i].prescriptionId, chemotherapyInfo[i], "CHEMOTHERAPY_ADMINISTRATION")
                          }
                        }

                      }}
                      disabled={chemotherapyInfo[i]?.isCancelled ? true : false || !chemotherapyInfo[i]?.medicines[0]?.medicineName || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
                      variant="primary"

                    >
                      {!val["id"] ? "Save" : "Update"}
                    </Button>
                    <Button
                      onClick={() => {
                        handleSendPrescription(chemotherapyInfo[i].prescriptionId, chemotherapyInfo[i], "CHEMOTHERAPY_ADMINISTRATION")
                      }}
                      disabled={chemotherapyInfo[i]?.readyToSent ? true : false || !val["id"] || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
                      variant="primary"

                    >
                      Send
                    </Button>
                    {/* <Button
                      onClick={() => {
                        //saveChemoOrder(values)
                        handleCancelPrescription(chemotherapyInfo[i].prescriptionId, chemotherapyInfo[i], "CHEMOTHERAPY_ADMINISTRATION")
                      }}
                      variant="primary"
                      disabled={chemotherapyInfo[i]?.isCancelled || !chemotherapyInfo[i]?.readyToSent ? true : false || readOnly}
                    >
                      Cancel
                    </Button> */}

                  </div>
                </> : <></>}
              </div>

            })}
          </div>
        </div>
      </div>
      {/* Take Home Medicine */}

      <div className="wrapper">
        <div className='prescription-flex' >
          {
            !readOnly && (
              <div
                style={{ marginLeft: '8px', marginBottom: '10px' }}
                className={`add-new-button-prescription ${!takeHomeMedicineInfo || takeHomeMedicineInfo.length === 0 || !takeHomeMedicineInfo[takeHomeMedicineInfo.length - 1]?.readyToSent ? 'test-none' : ''}`}
                onClick={() => {
                  const values = [...takeHomeMedicineInfo];
                  values.push({ ...takeHomeMedicine });
                  setTakeHomeMedicineInfo([...values]);
                  updateSelectedInputValues(preMedicationInfo, chemotherapyInfo, [...values])
                }}
              >
                Add New Prescription
              </div>
            )
          }

          {
            !readOnly && (
              <div>
                <div className='m-3'>
                  <Print
                    componentRef={componentRef}
                    buttonTitle='Print Prescription'
                  />
                </div>
              </div>
            )
          }
          <div></div>
        </div>
        <div key={renderKeyTake}>
          {takeHomeMedicineInfo?.map((val, i) => {
            return <div>
              <div className="dynamic-col-premedication">
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div style={{ display: 'flex' }}>
                    <label>Take Home Medicine</label>
                    {takeHomeMedicineInfo.length > 1 ? (
                      !readOnly && (
                        <div
                          style={{ marginLeft: '10px' }}
                          className="delete-icon"
                          onClick={() => {
                            if (takeHomeMedicineInfo.length > 1) {
                              const values = [...takeHomeMedicineInfo]
                              values.splice(i, 1)
                              setTakeHomeMedicineInfo(values)
                              updateSelectedInputValues(preMedicationInfo, chemotherapyInfo, values)
                            }
                          }}
                        >
                          <img
                            src="../../../../assets/images/delete-icon.svg"
                            alt=""
                          />
                        </div>
                      )) : (
                      !readOnly && (
                        <div
                          style={{ marginLeft: '10px', cursor: "not-allowed" }}
                          className="delete-icon"
                        >
                          <img
                            src="../../../../assets/images/delete-icon.svg"
                            alt=""
                          />
                        </div>)
                    )
                    }
                  </div>
                </div>
                <div className="table-heading-take">
                  <div className="pre-subHeading">Sr.no</div>
                  <div className="pre-subHeading">Type</div>
                  <div className="pre-subHeading">Medicine</div>
                  <div className="pre-subHeading">Dose</div>
                  <div className="pre-subHeading">When</div>
                  <div className="pre-subHeading">Frequency</div>
                  <div className="pre-subHeading">Duration</div>
                  <div className="pre-subHeading">Notes/<br />Instruction</div>
                  <div className="pre-subHeading">Side Effects</div>
                </div>
              </div>
              <DragDropContext
                onDragUpdate={(e: any) => { setUpdatedDragEvent(e); setTakeHome(val); }}
                onDragEnd={() => handleDragEndTakeHome(i)}>
                <Droppable droppableId="id-0015" isDropDisabled={false}>
                  {(provider: any) => (
                    <div className="dynamic-col" ref={provider.innerRef}
                      {...provider.droppableProps}>
                      {val?.medicines && val?.medicines?.map((item, j) => {
                        console.log("takeHomeMedicineInfo", takeHomeMedicineInfo)
                        return (
                          <Draggable
                            key={`id_${j}`}
                            draggableId={`id_${j}`}
                            index={j}
                          >
                            {(provider: any) => (
                              <TakeHomeMedicineRow
                                provider={provider}
                                takeHomeMedicineInfo={takeHomeMedicineInfo}
                                readOnly={readOnly}
                                appointmentDetails={appointmentDetails}
                                order={order}
                                i={i}
                                j={j}
                                setTakeHomeMedicineInfo={setTakeHomeMedicineInfo}
                                selectedInputValues={selectedInputValues}
                                title={title}
                                handleBlur={handleBlur}
                                newMedicine={newMedicine}
                                setSelectedInputValues={setSelectedInputValues}
                                handleInputChange={handleInputChange}
                                adjustTextareaHeight={adjustTextareaHeight}
                                handleChangeDuration={handleChangeDuration}
                                setInputValue={setInputValue}
                                options1={options1}
                                handleChange={handleChange}
                                allDrugs={totalMedicines}
                                whens={whens}
                                handleBlurFreq={handleBlurFreq}
                                frequencies={frequencies}
                                setShowToast={setShowToast}
                                handleInputChangeFreq={handleInputChangeFreq}
                                handleChangeDurationTake={handleChangeDurationTake}
                                optionsTake={optionsTake}
                                setInputValueTake={setInputValueTake}
                              />

                            )}
                          </Draggable>
                        )
                      })}
                      {
                        !readOnly && (
                          <button
                            style={{}}
                            className="add-new-button"
                            onClick={() => {
                              const values: any = [...takeHomeMedicineInfo]
                              values[i].medicines.push(takeHome)
                              setTakeHomeMedicineInfo([...values])

                              const selected: any = { ...selectedInputValues }
                              selected["takeHome"][i]["medicines"].push("")
                              selected["freq"][i]["freq"].push("")
                              setSelectedInputValues(selected)
                            }}
                            disabled={takeHomeMedicineInfo[i]?.isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
                          >
                            Add New
                          </button>
                        )
                      }

                      <div className="link cursor-pointer"
                        onClick={() => {
                          const values = [...takeHomeMedicineInfo]
                          values[i].sideEffectTakeHome = !values[i].sideEffectTakeHome;
                          setTakeHomeMedicineInfo([...values]);

                        }}
                      >Show Side Effects</div>

                      {takeHomeMedicineInfo[i]?.sideEffectTakeHome ? <>
                        <SideEffectsWS
                          onValueChange={(data: any, i: any, j: any) => {
                            const values = [...takeHomeMedicineInfo]
                            values[i].medicines[j].selectedSideEffects = data;
                            setTakeHomeMedicineInfo([...values]);

                          }}
                          allMedicinesSideEffect={totalMedicinesNew}
                          index={i}
                          values={takeHomeMedicineInfo}
                          dropdown={totalMedicinesSideHome}
                          readOnly={readOnly}
                          appointmentDetails={appointmentDetails}
                          order={order}
                        />
                      </> : <></>}

                    </div>
                  )}
                </Droppable>
              </DragDropContext>
              {isEditableOrder ? <>
                <div className="save-cancel-send">
                  <Button
                    onClick={() => {
                      if (!val["id"]) {
                        handleSavePrescription(takeHomeMedicineInfo[i].prescriptionId, takeHomeMedicineInfo[i], "TAKE_HOME_MEDICINE")
                      }
                      else {

                        if (takeHomeMedicineInfo[i]?.readyToSent) {
                          toggleDisplayToast({
                            text: "Prescription cannot be resent to Wondersoft as it was already sent once. The updated prescription will only be available in the MOC Application", type: 'warning',
                            onUpdate: true,
                            handleUpdatePrescription: () => handleUpdatePrescription(takeHomeMedicineInfo[i].prescriptionId, takeHomeMedicineInfo[i], "TAKE_HOME_MEDICINE")
                          })
                        } else {
                          handleUpdatePrescription(takeHomeMedicineInfo[i].prescriptionId, takeHomeMedicineInfo[i], "TAKE_HOME_MEDICINE")
                        }
                      }

                    }}
                    disabled={takeHomeMedicineInfo[i]?.isCancelled ? true : false || !takeHomeMedicineInfo[i]?.medicines[0]?.medicineName || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
                    variant="primary"
                  >
                    {!val["id"] ? "Save" : "Update"}
                  </Button>
                  <Button
                    onClick={() => {
                      handleSendPrescription(takeHomeMedicineInfo[i].prescriptionId, takeHomeMedicineInfo[i], "TAKE_HOME_MEDICINE")
                    }}
                    disabled={takeHomeMedicineInfo[i]?.readyToSent ? true : false || !val["id"] || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
                    variant="primary"
                  >
                    Send
                  </Button>

                </div>
              </> : <></>}
            </div>

          })}
        </div>
      </div>
      <div className="regimen-row">
        <div className='style-column'>
          <label>Next Cycle Frequency</label>
          <input
            type="text"
            className={`custom-input ${readOnly ? "read-only" : ""}`}
            name="cycleFrequency"
            value={initialValue.cycleFrequency}
            onChange={(e: any) => {
              setInitialValue({ ...initialValue, cycleFrequency: e.target.value })
            }}
            disabled={readOnly}
          />
        </div>
      </div>
      <div className="regimen-row">
        <div className='style-column'>
          <label>Procedure Notes</label>
          <textarea
            className={`custom-input-textArea ${readOnly ? "read-only" : ""}`}
            name="procedureNotes"
            rows={5}
            cols={10}
            disabled={readOnly}
            value={initialValue.procedureNotes}
            onChange={(e: any) => {
              setInitialValue({ ...initialValue, procedureNotes: e.target.value })
            }}
          />{" "}
        </div>
      </div>
      <div className="regimen-row">
        <div className='style-column'>
          <label>Clinical Notes</label>

          <textarea
            className={`custom-input-textArea ${readOnly ? "read-only" : ""}`}
            name="clinicalNotes"
            rows={5}
            cols={10}
            disabled={readOnly}
            value={initialValue.clinicalNotes}
            onChange={(e: any) => {
              setInitialValue({ ...initialValue, clinicalNotes: e.target.value })
            }}
          />{" "}
        </div>
      </div>

      <div className="regimen-row">

        <div className='style-column'>
          <label>Follow Up Date</label>
          <input
            type="date"
            className={`custom-input ${readOnly ? "read-only" : ""}`}
            name="followUpDate"
            value={initialValue.followUpDate}
            onChange={(e: any) => {
              setInitialValue({ ...initialValue, followUpDate: e.target.value })
            }}
            disabled={readOnly}
          />
        </div>


        <div className='style-column'>
          <label>Next Cycle On</label>
          <input
            type="date"
            value={initialValue.nextCycleOn}
            className={`custom-input ${readOnly ? "read-only" : ""}`}
            name="nextCycleOn"
            onChange={(e: any) => {
              setInitialValue({ ...initialValue, nextCycleOn: e.target.value })
            }}
            disabled={readOnly}
          />
        </div>
      </div>
      {/* Test Required */}
      <div className="wrapper">
        <div className="">
          <div className='prescription-flex'>
            {
              !readOnly && (
                <div
                  style={{ marginLeft: '8px', marginBottom: '10px' }}
                  className={`add-new-button-prescription ${!testRequiredInfo || testRequiredInfo?.length === 0 || !testRequiredInfo[testRequiredInfo?.length - 1]?.isSent ? "test-none" : ""}`}
                  onClick={() => {
                    const values: any = [...testRequiredInfo]
                    values.push(testRequired)
                    setTestRequiredInfo([...values])
                  }}
                >
                  Add New Test
                </div>
              )
            }
            {
              !readOnly && (
                <div>
                  <div className='m-3'>
                    <Print
                      componentRef={componentRef}
                      buttonTitle='Print Tests'
                    />
                  </div>
                </div>
              )
            }
          </div>
          {testRequiredInfo?.map((val: any, i: any) => {
            return <div>
              <div className="dynamic-col-premedication">
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div style={{ display: 'flex' }}>
                    <label>Test Required</label>
                    {testRequiredInfo.length > 1 ? (
                      !readOnly && (
                        <div
                          style={{ marginLeft: '10px' }}
                          className="delete-icon"
                          onClick={() => {

                            const values = [...testRequiredInfo]
                            if (values.length > 1) {
                              values.splice(i, 1)
                              setTestRequiredInfo(values)
                            }
                          }}
                        >
                          <img
                            src="../../../../assets/images/delete-icon.svg"
                            alt=""
                          />
                        </div>
                      )) : (
                      !readOnly && (
                        <div
                          style={{ marginLeft: '10px', cursor: "not-allowed" }}
                          className="delete-icon"
                        >
                          <img
                            src="../../../../assets/images/delete-icon.svg"
                            alt=""
                          />
                        </div>
                      ))
                    }
                  </div>
                </div>
                <div className="table-heading-test-required">
                  <div className="pre-subHeading">Sr.No</div>
                  <div className="pre-subHeading">Test</div>
                  <div className="pre-subHeading">Instructions</div>
                  <div className="pre-subHeading">Test(when)</div>
                </div>
              </div>
              <div className="dynamic-col">
                {val?.tests?.map((item: any, j: any) => {
                  console.log(":::::::", testsOptions.filter(({ value }: any) => value.value === item?.serviceId), 'testsOptions', testsOptions)
                  return (
                    <>
                      < div className="dynamic-parent-test" key={j} >
                        <div><div className={`dynamic-child ${readOnly ? "read-only" : ""} ${(
                          testRequiredInfo[i].isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))
                        ) ? "disabledDiv" : ""}`}>{j + 1}</div>
                        </div>
                        <div>
                          <Select
                            options={testsOptions}
                            defaultValue={testRequiredInfo[i].tests[j]?.serviceId}
                            onChange={(option: any) => {
                              const values = [...testRequiredInfo]
                              values[i].tests[j].serviceId = option?.value
                              values[i].tests[j].testName = option?.label
                              setTestRequiredInfo([...values]);
                            }}
                            className='dynamic-child'
                            value={testsOptions.filter(({ value }: any) => value === Number(item?.serviceId))}
                            isDisabled={testRequiredInfo[i].isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
                          />

                        </div>
                        <div>

                          <input
                            value={testRequiredInfo[i].tests[j]?.instructions}
                            className={`dynamic-child ${readOnly ? "read-only" : ""}`}
                            name="type"
                            onChange={(e: any) => {
                              const values = [...testRequiredInfo]
                              values[i].tests[j].instructions = e.target.value
                              setTestRequiredInfo([...values]);
                            }}
                            disabled={testRequiredInfo[i].isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
                          />
                        </div>

                        <div>
                          <input
                            style={{ paddingRight: '10px', paddingLeft: "10px" }}
                            type="date"
                            value={testRequiredInfo[i].tests[j]?.when
                              ? convertToYYYYMMDD(testRequiredInfo[i].tests[j]?.when)
                              : ''}
                            className={`dynamic-child ${readOnly ? "read-only" : ""}`}
                            name="type"
                            onChange={(e: any) => {
                              const values = [...testRequiredInfo]
                              values[i].tests[j].when = e.target.value
                              setTestRequiredInfo([...values]);
                            }}
                            disabled={testRequiredInfo[i].isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
                          />
                        </div>
                        {testRequiredInfo[i].tests.length > 1 ? (
                          !readOnly && (
                            <button
                              style={{ marginLeft: '10px', marginTop: '5px' }}
                              className="delete-icon"
                              onClick={() => {

                                const values = [...testRequiredInfo]
                                values[i].tests.splice(j, 1)
                                setTestRequiredInfo(values)

                              }}
                              disabled={testRequiredInfo[i].isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
                            >
                              <img
                                src="../../../../assets/images/delete-icon.svg"
                                alt=""
                              />
                            </button>
                          )) : (!readOnly && (
                            <button
                              style={{ marginLeft: '10px', marginTop: '5px', cursor: "not-allowed" }}
                              className="delete-icon"
                            >
                              <img
                                src="../../../../assets/images/delete-icon.svg"
                                alt=""
                              />
                            </button>
                          ))
                        }
                      </div>

                    </>
                  )
                })}

                {
                  !readOnly && (
                    <button
                      className="add-new-button"
                      onClick={() => {
                        const values: any = [...testRequiredInfo]
                        values[i].tests.push(initialTest)
                        setTestRequiredInfo([...values])
                      }}
                      disabled={testRequiredInfo[i].isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
                    >
                      Add New
                    </button>
                  )
                }

              </div>
              {isEditableOrder ? <>
                <div className="save-cancel-send">
                  <Button
                    onClick={() => {
                      //saveChemoOrder(values)
                      if (!val["id"]) { handleSaveTest(val) } else {
                        if (testRequiredInfo[i]?.isSent) {
                          toggleDisplayToast({
                            text: "Test Required cannot be resent to Suflam as it was already sent once. The updated test will only be available in the MOC Application.", type: 'warning',
                            onUpdate: true,
                            handleUpdatePrescription: () => handleUpdateTest(val)
                          })
                        }
                        else {
                          handleUpdateTest(val)
                        }
                      }
                    }}
                    variant="primary"
                    disabled={testRequiredInfo[i]?.isCancelled ? true : false || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
                  >
                    {!val["id"] ? "Save" : "Update"}
                  </Button>
                  <Button
                    onClick={() => {
                      //saveChemoOrder(values)
                      handleSendTest(val)
                    }}
                    variant="primary"
                    disabled={testRequiredInfo[i].isSent ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
                  >
                    Send
                  </Button>
                  <Button
                    onClick={() => {
                      //saveChemoOrder(values)
                      handleCancelTest(val)
                    }}
                    variant="primary"
                    disabled={testRequiredInfo[i].isCancelled || !testRequiredInfo[i].isSent ? true : false || readOnly}
                  >
                    Cancel
                  </Button>

                </div>
              </> : <></>}
            </div>

          })}


        </div>

      </div>

      {userRole === "CONSULTANT" ? <></> : <>
        <div className="template-row">
          <div className='style-column'>
            <label style={{ paddingTop: '10px', paddingBottom: '8px' }}>Select Consultant for Chemo Approval</label>

            <Select
              placeholder="Select Consultant Signature"
              options={consultantOptions}
              value={consultantOptions?.filter((item: any) => item?.value === initialValue?.consultantIdForApproval)}
              onChange={(evnt: any) => {
                setInitialValue({ ...initialValue, consultantIdForApproval: evnt.value })

              }}
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  border: "1px solid #ccd0e7",
                  borderRadius: "10px"
                })
              }}

              isDisabled={readOnly}
            />
          </div>
        </div>
      </>}



      {isEditableOrder ? (
        <div className="pending-button-row">
          {readOnly ? (<>
            <Button
              disabled
              onClick={() => {
                updateOrders()
              }}
              variant="primary"
              style={{ margin: "25px" }}
            >
              Update Chemo Order
            </Button></>) : (<><Button
              onClick={() => {
                updateOrders()
              }}
              disabled={disableChemoButton}
              variant="primary"
              style={{ margin: "25px" }}
            >
              Update Chemo Order
            </Button></>)}


        </div>
      ) : (
        <div>
          {readOnly ? (<Button
            onClick={() => {
              saveChemoOrder()
            }}
            disabled
            variant="primary"
            style={{ margin: "25px" }}
          >
            Save Chemo Order
          </Button>) : (<Button
            onClick={() => {
              saveChemoOrder()
            }}
            disabled={disableChemoButton}
            variant="primary"
            style={{ margin: "25px" }}
          >
            Save Chemo Order
          </Button>)}

        </div>
      )}

      <FollowUpPrint
        prescriptionPlansPrint={preMedicationInfo}
        takeHomeMedicinePrint={takeHomeMedicineInfo}
        chemotherapyPrint={chemotherapyInfo}
        testsRequestedPrint={testRequiredInfo}
        patientDetail={patientInfo}
        componentRef={componentRef}
        smartSummaryData={smartSummaryData}
        appointmentDate={appointmentDetails?.scheduleDate}
      />
      {displayToast && (
        <><div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9998,
          }}
        >
        </div>
          <Toast
            textMessage={displayToast?.text}
            type={displayToast?.type}
            onClose={() => {
              if (displayToast?.onUpdate) {
                displayToast?.handleUpdatePrescription();
              }
              if (displayToast?.text === "Chemo Order Created Successfully" || displayToast?.text === "Chemo Order Created Successfully") {
                redirectPendingOrder(1);
              }
              else {
                toggleDisplayToast(false)
              }

            }}
            onCloseText="Close"
            onClickText={null}
          />
        </>
      )}
      {showdrugValidation && (
        <Toast
          textMessage={`Check the UpperLimit ${drugDosage?.upperLimit === null ? "" : drugDosage?.upperLimit} `}
          onCloseText={"Close"}
          type={"error"}
          onClose={() => setShowdrugvalidation(false)}
        ></Toast>
      )}

      {
        open ? (
          <Toast
            textMessage={message}
            onCloseText={"Close"}
            onClose={() => setOpen(false)}
            type="success"
          ></Toast>
        ) : error ? (
          <Toast
            textMessage="Something went wrong, Please try again later."
            onCloseText={"Close"}
            onClose={() => setError(false)}
            type="error"
          ></Toast>
        ) : isLoading ? (
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 9999,
            }}
          >
            <div
              style={{ width: "3rem", height: "3rem" }}
              className="spinner-border text-primary"
            ></div>
          </div>
        ) : ""
      }
    </div>
  );
}

export default AddNewChemoOrderWS